import { PeerService } from "./services/Peer.service";

export const peerService = new PeerService();